var _IterableEnumerator_iterable, _IterableEnumerator_items, _IterableEnumerator_current, _IterableEnumerator_peak;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { NotSupportedException, OutOfBoundsException } from '../Exceptions';
import isUndefinedOrNull from '../TypeHelpers/isUndefinedOrNull';
import EnumeratorBase from './EnumeratorBase';
export default class IterableEnumerator extends EnumeratorBase {
    constructor(iterable) {
        super();
        // the internal array
        _IterableEnumerator_iterable.set(this, void 0);
        _IterableEnumerator_items.set(this, void 0);
        _IterableEnumerator_current.set(this, void 0);
        _IterableEnumerator_peak.set(this, void 0);
        __classPrivateFieldSet(this, _IterableEnumerator_iterable, iterable, "f");
        __classPrivateFieldSet(this, _IterableEnumerator_items, IterableEnumerator.items(__classPrivateFieldGet(this, _IterableEnumerator_iterable, "f")), "f");
    }
    get current() {
        if (!isUndefinedOrNull(__classPrivateFieldGet(this, _IterableEnumerator_current, "f"))) {
            const value = __classPrivateFieldGet(this, _IterableEnumerator_current, "f").value;
            if (value === void (0)) {
                throw new OutOfBoundsException("[void] Must call moveNext() before getting current.", -1, -1);
            }
            return value;
        }
        throw new OutOfBoundsException("Must call moveNext() before getting current.", -1, -1);
    }
    moveNext() {
        if (!isUndefinedOrNull(__classPrivateFieldGet(this, _IterableEnumerator_peak, "f"))) {
            __classPrivateFieldSet(this, _IterableEnumerator_current, __classPrivateFieldGet(this, _IterableEnumerator_peak, "f"), "f");
            __classPrivateFieldSet(this, _IterableEnumerator_peak, undefined, "f");
        }
        else {
            __classPrivateFieldSet(this, _IterableEnumerator_current, __classPrivateFieldGet(this, _IterableEnumerator_items, "f").next(), "f");
        }
        return !__classPrivateFieldGet(this, _IterableEnumerator_current, "f").done;
    }
    /**
     * returns the next element without moving the pointer forwards
     * @throws {NotSupportedException} Iterables cannot be peeked. Consider using BufferedIterableEnumerator.
     */
    peek() {
        throw new NotSupportedException("Iterables cannot be peeked. Consider using BufferedIterableEnumerator.");
    }
    /**
     * reset the pointer to the start
     * @throws {NotSupportedException} Iterables cannot be reset. Consider using BufferedIterableEnumerator.
     */
    reset() {
        throw new NotSupportedException("Iterables cannot be reset. Consider using BufferedIterableEnumerator.");
    }
    static *items(iterable) {
        for (const item of iterable) {
            yield item;
        }
    }
}
_IterableEnumerator_iterable = new WeakMap(), _IterableEnumerator_items = new WeakMap(), _IterableEnumerator_current = new WeakMap(), _IterableEnumerator_peak = new WeakMap();
